import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { StatisticsContext } from "@pages/Statistics/context";

import DownloadDropdown from "@components/Common/OldDownloadDropdown";
import CustomErrorBoundary from "@components/Common/CustomErrorBoundary";

import TitleRow from "@components/Common/TitleRow";
import SalesModeCol from "./SalesModeCol";
import StatisticsSalesModeCol from "./StatisticsSalesModeCol";

export default function SalesModeRow() {
    const { t } = useTranslation();

    const { period, type, advancedDate, selections } = useSelector(
        (state: any) => state
    );

    const [percentageData, setPercentageData] = React.useState<any[]>([]);
    const [histogramData, setHistogramData] = React.useState<any[]>([]);
    const [categoriesData, setCategoriesData] = React.useState<any[]>([]);

    return (
        <React.Fragment>
            <StatisticsContext.Provider
                value={{
                    period,
                    type,
                    advancedDate,
                    selections,
                    percentageData,
                    setPercentageData,
                    histogramData,
                    setHistogramData,
                    categoriesData,
                    setCategoriesData,
                }}
            >
                <TitleRow title={t("Sales mode")}>
                    <DownloadDropdown />
                </TitleRow>
                <div className="d-grid__clz grid-gap__clz grid-xl-statistics-template-col__clz grid-lg-statistics-template-col__clz grid-statistics-template-col__clz grid-sm-template-col__clz grid-xs-template-col__clz">
                    <CustomErrorBoundary>
                        <SalesModeCol />
                    </CustomErrorBoundary>
                    <CustomErrorBoundary>
                        <StatisticsSalesModeCol />
                    </CustomErrorBoundary>
                </div>
            </StatisticsContext.Provider>
        </React.Fragment>
    );
}
